import Vue from 'vue'
import Vuex from 'vuex'
import util from './modules/util.js'
import teletrabajo from './modules/teletrabajo.js'
import general from './modules/general.js'
import gerencia from './modules/gerencia.js'
import login from './modules/login.js'
import rrhh from './modules/rrhh.js'
import configuradorOferta from './modules/configuradorOferta.js'
import areaPersonal from './modules/AreaPersonal'
import deviceManagement from './modules/deviceManagement.js'
import dashboard from './modules/dashboard.js'
import ManagementBase from './modules/ManagementBase'
import tutorials from './modules/tutorials.js'
import statistics from './modules/statistics.js'
import coverage from './modules/coverage.js'
import coverageAvatel from './modules/coverageAvatel.js'
import orders from './modules/orders.js'
import resources from './modules/resources.js'
import objectivesReport from './modules/objectivesReport.js'
import tenantManagement from './modules/tenantManagement.js'
import holidays from './modules/holidays.js'
import reportTable from './modules/reportTable'
import databaseManagement from './modules/DatabaseManagement'
import retailX from './modules/RetailX.js'
import punchIn from './modules/punchIn'
import storage from './modules/storage'
import lowi from './modules/Lowi'
import agent from './modules/agent'

// import products from './modules/products'
// import createLogger from '../../../src/plugins/logger'

Vue.use(Vuex)

// const debug = process.env.NODE_ENV !== 'production'

export default new Vuex.Store({
    modules: {
        util,
        teletrabajo,
        general,
        gerencia,
        areaPersonal,
        ManagementBase,
        login,
        rrhh,
        configuradorOferta,
        dashboard,
        deviceManagement,
        tutorials,
        statistics,
        coverage,
        coverageAvatel,
        resources,
        objectivesReport,
        tenantManagement,
        holidays,
        orders,
        reportTable,
        databaseManagement,
        retailX,
        punchIn,
        storage,
        lowi,
        agent
    },
})
